import { apiInterceptor } from 'utils/apiInterceptor';
/**
 * Update the isPublished livepage settings
 * @param  {string} livepageId
 * @param  {string} status  'publish'|'unpublish'
 * @category Venue Builder
 */
const updateLivePageStatus = async (livepageId,projectId, status = 'publish') => {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/showcases/${livepageId}/${status}?projectId=${projectId}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );

    return await response.json();
};
export default updateLivePageStatus;
